import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import i18n from '@/i18n';
import { Criticality } from '@/api';
import SEllipsisTooltip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';

export type SeveritySize = 'small' | 'default';

interface SeverityProps {
  /**
   * Chip size
   */
  size?: SeveritySize;
  /**
   * Display icon only
   */
  iconOnly?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Severity',
  props: {
  size: { default: 'default' },
  iconOnly: { type: Boolean, default: false },
  value: null
},
  emits: ["input"],
  setup(__props) {

const props = __props;

/**
 *
 * Display incident severity with icon / color and label,
 * from the provided severity value
 *
 */

const { value: severity } = __MACROS_useVModel(["value", undefined, "input"]);

const text = _computed(() => {
  switch (severity.value) {
    case Criticality.CRITICAL:
    case 0:
      return i18n.t('criticality.critical');
    case Criticality.HIGH:
    case 1:
      return i18n.t('criticality.high');
    case Criticality.MODERATE:
    case 2:
      return i18n.t('criticality.moderate');
    case Criticality.LOW:
    case 3:
      return i18n.t('criticality.low');
    default:
      return '';
  }
});

const textClasses = _computed(() => ((props.size === 'small') ? ['lh-1', 'grey--text'] : []));

const color = _computed(() => {
  switch (severity.value) {
    case Criticality.CRITICAL:
    case 0:
      return 'iconDanger';
    case Criticality.HIGH:
    case 1:
      return 'iconAttention';
    case Criticality.MODERATE:
    case 2:
      return 'iconWarning';
    case Criticality.LOW:
    case 3:
      return 'iconNeutral';
    default:
      return undefined;
  }
});

const icon = _computed(() => {
  switch (severity.value) {
    case Criticality.CRITICAL:
    case 0:
      return 'icon-chevron-triple-up';
    case Criticality.HIGH:
    case 1:
      return 'icon-chevron-double-up';
    case Criticality.MODERATE:
    case 2:
      return 'icon-chevron-up';
    case Criticality.LOW:
    case 3:
    default:
      return 'icon-subtract-middle';
  }
});


return { __sfc: true,props, severity, text, textClasses, color, icon, _computed, __MACROS_useVModel, i18n, Criticality, SEllipsisTooltip }
}

})